import { HttpClient } from "@angular/common/http";
import { AbstractService } from "../../core/AbstractService";
import { env } from "../../../env/env";
import { Injectable, Injector } from "@angular/core";
import { AppService } from "../../core/app.service";
import { ParametrageStructureProgrammatiqueRequest } from "../../data/http/requests/parametragestructureprogrammatique.request";
import { ParametrageStructureProgrammatiqueResponse } from "../../data/http/responses/parametragestructureprogrammatique.response";
@Injectable({
    providedIn: 'root'
})
export class ParametrageStructureProgrammatiqueService extends AbstractService<ParametrageStructureProgrammatiqueRequest, ParametrageStructureProgrammatiqueResponse> {

    constructor(http: HttpClient, injector: Injector, appService: AppService) {
        // Do not rely on a CookiesService import here; pass null and let AbstractService use AppService
        super(`${env.apiUrl}parametrage-structure-programmatique`, http, null, appService ); 
    }
/* 
    // Exemple d'une méthode personnalisée qui retourne un Observable
    getActiveUsers(): Observable<ApiResponse<TypeInterventionResponse[]>> {
        // Vous pouvez utiliser les méthodes héritées ou créer des méthodes spécifiques
        return this.http.get<ApiResponse<TypeInterventionResponse[]>>(`${this.baseUrl}`).pipe(
            catchError(this.handleError) // Utilisez la gestion d'erreur héritée
        );
    } */
}